// Component to change the range dates (weekly) of current dispatch schedule
import { useSchedulerContext } from '@/context/SchedulerContext';

import WeekPicker, { WeekObject } from '@/components/WeekPicker/WeekPicker';

export default function SchedulerRange() {
  const {
    schedulerStartDate,
    schedulerEndDate,
    schedulerCurrentDate,
    setSchedulerRangeDates,
  } = useSchedulerContext();

  const onChangeWeek = (week: WeekObject) => {
    setSchedulerRangeDates(week.firstDay, week.lastDay, week.selectedDay);
  };

  return (
    <div className="scheduler-range flex flex-1 justify-end md:py-5">
      <WeekPicker
        startDate={schedulerStartDate}
        endDate={schedulerEndDate}
        selectedDate={schedulerCurrentDate}
        onChange={onChangeWeek}
      />
    </div>
  );
}
